export function readPreference(key: string): boolean {
  try { return localStorage.getItem(`dwik:${key}`) === "true"; } catch { return false; }
}
export function savePreference(key: string, value: boolean): void {
  try { localStorage.setItem(`dwik:${key}`, String(value)); } catch { /* private browsing */ }
  window.dispatchEvent(new Event("dwik-preference"));
}
